export const Rights = [
    "WEB_MODULE_PILOTS_READ"   
]
